module.exports = __webpack_public_path__ + "catalog/items/furniture/Rug/Rug.svg";